import React from 'react'
import Uploader from '@liveramp/motif/core/Uploader'

export default function DisabledDemo() {
  return <Uploader id="disabled-uploader" disabled />
}
